import script from "./pending-approvals.vue?vue&type=script&setup=true&lang=js"
export * from "./pending-approvals.vue?vue&type=script&setup=true&lang=js"

import "./pending-approvals.vue?vue&type=style&index=0&id=a9b3f800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b3f800"]])

export default __exports__